import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "About", to: "about" },
  { label: "Work", to: "work" },
  { label: "Experience", to: "experience" },
  { label: "Journal", to: "journal" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 120);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-300 ${
        scrolled ? "bg-white/70 backdrop-blur-xl border-b border-slate-200/60 shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl section-x flex items-center justify-between h-20">
        <Link
          to="/"
          data-testid="logo-link"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-serif text-xl tracking-tight text-navy flex items-center gap-2"
        >
          <span className="inline-block w-2.5 h-2.5 bg-berry rotate-45" />
          Natalia Halipchak
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.to}
              data-testid={`nav-${l.to}`}
              onClick={() => goTo(l.to)}
              className="text-sm text-slate-700 hover:text-berry transition-colors duration-200 relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-berry transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
          <button
            data-testid="nav-contact-cta"
            onClick={() => goTo("contact")}
            className="bg-berry hover:bg-berry-dark text-white text-sm px-5 py-2.5 rounded-sm transition-colors duration-200 hover:scale-[1.03] active:scale-95"
          >
            Contact Me
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-navy"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-slate-200 section-x py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <button
              key={l.to}
              data-testid={`mobile-nav-${l.to}`}
              onClick={() => goTo(l.to)}
              className="text-left text-slate-800 text-lg"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-nav-contact"
            onClick={() => goTo("contact")}
            className="bg-berry text-white px-5 py-3 rounded-sm text-left"
          >
            Contact Me
          </button>
        </div>
      )}
    </header>
  );
};
